import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import HeadTitle from '../../components/headTitle/';
import ResearchSearch from './researchSearch/';
import Caption from '../../components/caption';
import NewsList from '../../components/newsList';
import TableTitle from '../../components/tableTitle/';
import StarAnalyst from './starAnalyst/';
import StockPicking from './stockPicking/';
import NewsLine from './newsLine/';
import ClickMore from '../../components/clickMore';

class School extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        link: 'https://finance.ifeng.com/shanklist/1-62-83-',
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const logsList = content.logs;
        const gsxtData = content.gsxtData;

        const { link } = this.state;

        const tempObj = {};

        const newGsxtData = gsxtData.reduce((preValue, item) => {
            
            // eslint-disable-next-line no-unused-expressions
            tempObj[item.commentUrl] ? '' : tempObj[item.commentUrl] = true && preValue.push(item);

            return preValue;

        }, []);

        const {
            starAnalystTitle,
            starAnalyst,
            starSrank,
            starMrank,
            starLrank,
            stockPickingTitle,
            stockpool,
            stockpoolData,
            chgpctest,
            chgpctestData,
            levelup,
            levelupData,
            firstfocus,
            firstfocusData,
            focusest,
            focusestData,
        } = content;
        const starAnalystData = [starAnalyst, starSrank, starMrank, starLrank];
        const stockPickingData = [
            [stockpool, stockpoolData],
            [chgpctest, chgpctestData],
            [levelup, levelupData],
            [firstfocus, firstfocusData],
            [focusest, focusestData],
        ];

        return (
            <div className={`${styles.school} clearfix`}>
                <Chip
                    id="20068"
                    type="struct"
                    title="高手学堂标题"
                    groupName="高手学堂"
                    content={content.schoolTitle}
                    position="relative">
                    <HeadTitle>
                        <ResearchSearch />
                    </HeadTitle>
                </Chip>
                <div className={styles.col_L}>
                    <div className={styles.box}>
                        {newGsxtData.slice(0, 5).map((item, index) => <NewsLine content={item} key={index} />)}
                    </div>
                    <ClickMore link={link} />
                    <div className={styles.ad}>
                        <NoSSR onSSR={<div className={styles.ad_box} />}>
                            <Ad content={content.schoolAd} styleName={styles.ad_box} />
                        </NoSSR>
                    </div>
                </div>
                <div className={styles.col_R}>
                    <div>
                        <Chip
                            id="20071"
                            type="struct"
                            title="明星分析师标题"
                            groupName="高手学堂"
                            content={starAnalystTitle}
                            position="relative">
                            <TableTitle />
                        </Chip>
                        <StarAnalyst tabs={starAnalystTitle.tabs} content={starAnalystData} />
                    </div>
                    <div className={styles.data_box}>
                        <Chip
                            id="20073"
                            type="struct"
                            title="研报选股标题"
                            groupName="高手学堂"
                            content={stockPickingTitle}
                            position="relative">
                            <TableTitle />
                        </Chip>
                        <StockPicking tabs={stockPickingTitle.tabs} content={stockPickingData} />
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(School);
